/* src/app/main/sales/wizard/steps/sheet-selection/sales-sheet-selection.component.scss */
@font-face {
  font-family: "Noto Sans";
  src: url("./media/NotoSans-Regular-ZNAPSC3M.ttf");
  src:
    url("./media/NotoSans-Regular-ZNAPSC3M.ttf") format("truetype"),
    url("./media/NotoSans-BoldItalic-3JQC5OZS.ttf") format("truetype"),
    url("./media/NotoSans-Bold-GRYZZLHD.ttf") format("truetype"),
    url("./media/NotoSans-Italic-5X45VU5J.ttf") format("truetype"),
    url("./media/NotoSans-Light-JP6O7GL4.ttf") format("truetype"),
    url("./media/NotoSans-LightItalic-5YVFDRZM.ttf") format("truetype"),
    url("./media/NotoSans-Medium-NN452WKZ.ttf") format("truetype"),
    url("./media/NotoSans-MediumItalic-ZRI6HATP.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Marsh Serif";
  src: url("./media/MarshSerif-Regular-FTLVEPD5.woff2") format("woff2");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Marsh Serif";
  src: url("./media/MarshSerif-Italic-H4EFZXHC.woff2") format("woff2");
  font-weight: normal;
  font-style: italic;
}
body {
  margin: 0;
}
main {
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  font-family: "Noto Sans", sans-serif;
  font-size: 11pt;
}
@media (max-width: 2560px) {
  main {
    font-size: 11pt;
  }
}
@media (max-width: 1280px) {
  main {
    font-size: 8pt;
  }
}
@media (max-width: 1080px) {
  main {
    font-size: 8pt;
  }
}
h1 {
  color: #1b638b;
  font-weight: normal;
  font-size: 50px;
  font-family: "Marsh Serif", serif;
}
h4 {
  color: #1b638b;
  font-weight: normal;
  font-size: 30px;
  font-family: "Marsh Serif", serif;
  margin-top: 0px;
  margin-bottom: 20px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
button {
  padding-top: 10px;
  padding-bottom: 10px;
  padding-inline-start: 12px;
  padding-inline-end: 12px;
  border: solid;
  border-width: 2px;
  border-color: #006f8a;
  border-radius: 10px;
  background-color: #ffffff;
  color: #006f8a;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
button:hover {
  background-color: #d7ecf7;
}
button:active {
  transform: scale(0.95);
}
.button-success {
  color: #17c280;
  border-color: #17c280;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.button-success:hover {
  background-color: #d7ecf7;
}
.button-success:active {
  transform: scale(0.95);
}
.button-confirm {
  color: #f7914d;
  border-color: #f7914d;
  margin-inline-start: 2.5px;
  margin-inline-end: 2.5px;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.button-confirm:hover {
  background-color: #d7ecf7;
}
.button-confirm:active {
  transform: scale(0.95);
}
.button-cancel {
  color: #777777;
  border-color: #777777;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
.button-cancel:hover {
  background-color: #d7ecf7;
}
.button-cancel:active {
  transform: scale(0.95);
}
.background-color-primary {
  background-color: #002c77;
  color: #ffffff;
}
.background-color-secondary {
  background-color: #006f8a;
  background:
    linear-gradient(
      to bottom,
      #006f8a,
      #01576d);
  color: #ffffff;
}
.background-color-light {
  background-color: #ffffff;
  color: #1d1d1d;
}
.background-color-dark {
  background-color: #272727;
  color: #ffffff;
}
.background-color-semi-dark {
  background-color: #222222;
  color: #ffffff;
}
.loading-spinner {
  display: inline-block;
  margin-left: 8px;
  width: 8px;
  height: 8px;
  border: 2px solid rgba(0, 150.652173913, 189, 0.4196078431);
  border-top-color: transparent;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
label.pill {
  width: fit-content;
  align-items: center;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 5px;
  margin-bottom: 0px;
  border: solid;
  border-width: thin;
  border-color: #006f8a;
  border-radius: 30px;
  color: #006f8a;
  background-color: #d7ecf7;
  animation: pill-appear 0.6s cubic-bezier(0.4, 0, 0.2, 1);
}
label.pill.gray {
  border-color: #aaaaaa;
  color: #aaaaaa;
  background-color: #fafafa;
}
span.pill-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: fit-content;
  width: fit-content;
  margin-top: 10px;
  margin-bottom: 10px;
}
button.pill-button {
  width: fit-content;
  height: fit-content;
  padding-top: 9px;
  padding-bottom: 9px;
  padding-left: 10px;
  padding-right: 10px;
  margin-left: 5px;
  margin-bottom: 0px;
  border: solid;
  border-width: thin;
  border-color: #006f8a;
  border-radius: 30px;
  color: #006f8a;
  background-color: #ffffff;
  transition: background-color 0.3s ease, transform 0.2s ease;
}
button.pill-button:hover {
  background-color: #d7ecf7;
}
button.pill-button:active {
  transform: scale(0.95);
}
@keyframes pill-appear {
  0% {
    transform: scale(0.6);
    opacity: 0.2;
  }
  70% {
    transform: scale(1.04);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
.osano-cm-link {
  display: none;
}
.osano-cm-widget {
  display: none;
}
h3 {
  font-size: 22px;
  font-weight: normal;
  color: #002c77;
  margin-bottom: 20px;
}
.worksheets-container {
  margin-top: 20px;
  margin-bottom: 30px;
}
.worksheet-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  gap: 8px;
}
.worksheet-item input[type=checkbox] {
  margin-right: 2px;
}
.worksheet-item select {
  margin-left: 20px;
  padding: 5px;
  font-size: 14px;
}
input[type=checkbox]:checked {
  accent-color: #006f8a;
}
input[type=checkbox] {
  width: 20px;
  height: 20px;
  cursor: pointer;
}
select {
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 4px;
  background-color: #fff;
  font-size: 14px;
  transition: box-shadow 0.3s ease-in-out;
}
select .invalid {
  outline-color: rgb(240.7971014493, 164.2028985507, 173.3333333333);
  outline-offset: -1px;
  outline-width: 0.5px;
  outline-style: solid;
}
select:hover,
select:focus {
  box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.2);
  border-color: #006f8a;
  outline: none;
}
.error-message {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
.loading-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 4px;
  margin: 20px 0;
}
.loading-indicator .spinner {
  width: 24px;
  height: 24px;
  border: 3px solid #e0e0e0;
  border-top-color: #006f8a;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
/*# sourceMappingURL=sales-sheet-selection.component-H5MDSVZU.css.map */
